import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  constructor() {}
  public show() {}
  public hide() {}
}
